module.exports = __webpack_public_path__ + "static/media/unknown-icon.a404c338.svg";